// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal-styles_backdrop__3bl4m","dialog":"Modal-styles_dialog__3vbjA"};